import {Component, OnInit} from '@angular/core';
import {I18NextService} from 'angular-i18next';
import {CompanyService} from '../company.service';
import {MessageService} from 'primeng/api';
import {ActivatedRoute, Router} from '@angular/router';
import {Model} from "../../app.model";
import {Contact} from "../company.model";
import {FormEmitter} from "../../forms/form.component";

@Component({
    selector: 'app-contact-invite',
    templateUrl: './contact-invite.component.html',
    styleUrls: [],
    standalone: false
})
export class ContactInviteComponent implements OnInit {
  public customerId: string;
  public showPermissionText = false;

  is20CSP: boolean;


  constructor(private i18next: I18NextService,
              private companyService: CompanyService,
              private messageService: MessageService,
              private router: Router,
              private m: Model,
              private route: ActivatedRoute) { }

  ngOnInit() {
    this.customerId = this.route.snapshot.paramMap.get('customerId');
    this.is20CSP = this.m.account.currentUser.companyIsPC20Csp;
  }

  onCreateSubmit(form: FormEmitter<Contact>) {
    const contact = form.data;
    if (this.isPartnerInvite) {
      contact.company_id = this.customerId;
    }

    if (this.is20CSP && !!this.customerId) {
      this.inviteCspContact(contact);
      return;
    }

    this.inviteContact(contact);
  }

  onInviteSubmit(form: FormEmitter<Contact>) {
    const contact = form.data;
    contact.id = '';
    contact.email = this.is20CSP ? undefined : contact.email;
    contact.invite_user = this.is20CSP ? undefined : contact.invite_user;
    contact.mypascom_account = 'disabled';

    if (this.isPartnerInvite) {
      contact.company_id = this.customerId;
    }

    if (this.is20CSP && !!this.customerId) {
      this.inviteCspContact(contact);
      return;
    }

    this.inviteContact(contact);
  }

  inviteContact(c: Contact) {
    this.companyService.inviteContact(c).subscribe(() => {
      if (c.invite_user) {
        this.messageService.add({
          severity: 'success',
          summary: this.i18next.t('success') as string,
          detail: this.i18next.t('contact_invited') as string
        });
      } else {
        this.messageService.add({
          severity: 'success',
          summary: this.i18next.t('success') as string,
          detail: this.i18next.t('contact_created') as string
        });
      }
      this.navigate(c);
    });
  }

  inviteCspContact(c: Contact) {
    this.companyService.addCSPContact(c).subscribe(() => {
      this.messageService.add({
        severity: 'success',
        summary: this.i18next.t('success') as string,
        detail: this.i18next.t('contact_created') as string
      });

      this.navigate(c);
    });
  }

  navigate(c: Contact) {
    if (!!c.company_id) {
      this.router.navigate(['/customers', c.company_id, 'contacts']);
    } else {
      this.router.navigate(['/company/contacts/']);
    }
  }

  get isPartnerInvite() {
    return !!this.customerId;
  }


}
